(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1551],{

/***/ 54899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/mercari-vacation-mode/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2021-08-10",
      tag: "Poshmark",
      title: "Mercari Tip: How To Turn On Vacation Mode On Your Account",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The prominence of the online marketplace has made it easier for people to earn and at the same time, give away their pre-loved items\u2014similar to a garage sale. On one hand, this is a great exchange but on the other hand, it makes it difficult to know which platform works best for you. Thankfully, some features distinguish them from each other."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "In Mercari, one of the biggest online selling platforms in the United States, has a Vacation Mode. This feature on the Mercari store is most useful when a seller needs to take time off from being active on the platform."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Why go on Vacation Mode?"
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Being active on Mercari keeps your account busy\u2014be it putting out new listings, tweaking existing ones, and answering potential buyer questions. Continuous activity on the shopping destination and even social media is a good sign for users to look into your offers and encourage them to make a purchase. After all, it is a big marketplace\u2014a vibrant community with hundreds of merchants or Mercari vendors. There is a huge selection of offerings with various price options so you have to compete with them all."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "However, there are times when, as a seller, you will have to take time off for a while. You may have different plans such as going out of town or out of the country, focusing on a full-time job, or tending to personal errands."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "No matter the reason, you will be unable to attend to matters concerning your Mercari listings. It will be inconvenient for you to bring your products with you on your trip. Similar applies to answering inquiry submissions\u2014these can be a hassle when you are trying to enjoy your break."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "One of the biggest money mistakes you can make is being unable to tend to customer issues without a proper announcement of your inactivity. The end result of this is driving away potential buyers, being flagged as an odd seller especially when there is a negative Mercari online store review."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This is when the Vacation Mode of Mercari comes in handy. Having a growing presence online is important but your personal life is equally essential."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Positives of the feature"
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The way Mercari Vacation Mode works is that it allows you to inform users you will be inactive for some time. You can modify the time period or time limit of turning on the Vacation Mode\u2014from a certain number of days, a week, to a month or so. This can be changed in the system preferences or \"time away settings\" similar to the eBay store."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Additionally, you can select which Mercari listings to temporarily deactivate through your account settings. In this way, you can block purchases or monitor activity and sales on particular offerings."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Deactivate your listing"
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "To turn on Vacation Mode, you will only need simple steps. First, go to your web browser and log in to your Mercari account. Head to your account tab and tap the selling icon on the top right corner of the selecting page (seen on the right side of the page). Here you will see your listings on the Selling page. You can choose which items to deactivate."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "For notifications of new posts, you may toggle this in your user account label. You have the freedom to hide them when you change settings section of the messages. In this way, you can have either fewer notifications or none at all. To change this, go to your profile, then settings, and notifications."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "To turn Vacation Mode off or to cancel, sign in to your Mercari seller account and follow the similar steps above. Once you have deselected the inactive items, you are now back online and ready to manage your local sales."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Technical issues"
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you encounter a technical issue, head to Mercari's Help Center. This acts as a blog, seller guidelines, or customer service where you can get the answers you are looking for. It ranges from account questions to website crashes. Simply type your question on the \u201CSearch\u201D tab. The articles are easy to understand, acting as a dedicated senior support service."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Before you turn on Vacation Mode and take your time off, you may also opt to reach out to a family member or a friend. You can let them know your Mercari login email address or username and password so they can take over you while you are away. You can also tell them to message you on your phone number for urgent concerns. This is a form of faster assistance when there is a clearance sale or a price listing you want to keep active like higher-priced electronics."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The person can also tend to urgent customer queries such as a problem with the receipt, an emergency return request, a claim for a full refund, credit card issues, or when you need to transfer money or do shipments today. Make sure you are made aware of details such as the return date and post office schedule. With this, you can go on full holiday mode while someone you trust has convenient access to your listings. This is most helpful when you have less time to sell items but at the same time, prefer to have a rapid expansion of your account."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Lastly, advise them to have a lot of patience in dealing with a Mercari customer, especially if this is their first time handling business accounts on the Mercari platform. All these tips make for a great experience not only for you as a seller but also for your customers."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Looking to boost your business and expand to different marketplaces such as Poshmark and Tradesy? Try OneShop, with helpful listing tools and automatic delisting, as well as helpful automation tools that help with marketing in multiple marketplaces. Give us a try at OneShop. OneShop offers a no-risk, seven-day free trial with a responsive support team ready to answer all your questions and help you with your closet's needs. If you are ready to experience an intelligent software built to help you grow your business, all you have to do is sign-up here."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/mercari-vacation-mode.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "The Comprehensive Guide To Mercari\u2019s Vacation Mode"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Going on Vacation? Take a break, but be sure your Mercari business is put on pause!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/mercari-vacation-mode"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/mercari-vacation-mode"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "The Comprehensive Guide To Mercari\u2019s Vacation Mode"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Going on Vacation? Take a break, but be sure your Mercari business is put on pause!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2021-08-10T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2021-08-10T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Mercari"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 46938:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/mercari-vacation-mode",
      function () {
        return __webpack_require__(54899);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(46938); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);